import { useEffect, useRef, useState } from "react";
import {
  calculateTermBoardLayout,
  evaluateTermGuesses,
  normalizeTermWord,
  termKeyboardState,
} from "../../domain/term.js";
import { GameKeyboard } from "./GameKeyboard.jsx";
import { TermGrid } from "./TermGrid.jsx";

export function TermBoards({ secrets, maxAttempts, engine }) {
  const container = useRef(null);
  const [layout, setLayout] = useState({
    columns: Number(secrets.length) || 1,
    cell: 40,
  });

  useEffect(() => {
    const resize = () => {
      const width = container.current?.clientWidth || 0;
      if (width > 0) setLayout(calculateTermBoardLayout(width, secrets.length));
    };
    resize();
    const observer = new ResizeObserver(resize);
    if (container.current) observer.observe(container.current);
    window.addEventListener("resize", resize);
    window.addEventListener("orientationchange", resize);
    return () => {
      observer.disconnect();
      window.removeEventListener("resize", resize);
      window.removeEventListener("orientationchange", resize);
    };
  }, [secrets.length]);

  const rows = Math.ceil(secrets.length / layout.columns);
  return (
    <>
      <div
        className="board-area"
        ref={container}
        style={{ alignItems: rows > 1 ? "flex-start" : "center" }}
      >
        <div
          className="board-grid"
          style={{
            gridTemplateColumns: `repeat(${layout.columns}, auto)`,
            columnGap: 16,
            rowGap: 28,
          }}
        >
          {secrets.map((secret, index) => {
            const solved = engine.guesses.includes(normalizeTermWord(secret));
            return (
              <div
                className={solved ? "term-board-solved" : ""}
                key={`${secret}-${index}`}
              >
                <TermGrid
                  palpites={evaluateTermGuesses(secret, engine.guesses)}
                  letrasAtuais={solved ? Array(5).fill("") : engine.letters}
                  linhaAtual={engine.guesses.length}
                  maxTentativas={maxAttempts}
                  indexAtivo={solved ? -1 : engine.activeIndex}
                  onCellClick={(column) => !solved && engine.selectCell(column)}
                  cellSize={layout.cell}
                />
              </div>
            );
          })}
        </div>
      </div>
      <GameKeyboard
        aoDigitar={engine.type}
        estadoTeclas={termKeyboardState(secrets, engine.guesses)}
      />
    </>
  );
}

export function SecretWords({ secrets, label = "Palavras secretas:" }) {
  return (
    <div className="term-secret-box">
      <p>{label}</p>
      <div>
        {secrets.map((secret, index) => (
          <span key={`${secret}-${index}`}>{secret.toUpperCase()}</span>
        ))}
      </div>
    </div>
  );
}
